import { inject, Injectable } from '@angular/core';
import { fromSadmEntityResponse } from '@modules/sadm/adapters/sadm-entity-display.adapter';
import { Patient } from '@pixacare/domain';
import { SadmEntityResponse } from '@pixacare/dtos';
import { SadmHttpService } from '@services/http/sadm.http.service';
import { map, Observable } from 'rxjs';
import { SadmEntityDisplay } from '../../../models/sadm-entity-display';

@Injectable()
export class SadmGridDataService {
  private readonly sadmHttp = inject(SadmHttpService);

  loadEntities(sadmClientId: number, clientCode: string, patient: Patient): Observable<SadmEntityDisplay[]> {
    return this.sadmHttp
      .getSadmEntities({
        patientId: patient.id,
        sadmClientId,
        clientCode,
        flattened: true,
        includeProtocolsHistory: true,
        includeEntityCreationFormAnswer: true,
        isArchived: false,
      })
      .pipe(
        map((response: SadmEntityResponse[]): SadmEntityDisplay[] =>
          // The grid only opens with a sadm client the user is assigned to.
          response.map((sadmEntityResponse) =>
            fromSadmEntityResponse(sadmEntityResponse, patient, { isSadmClientAssigned: true }),
          ),
        ),
      );
  }
}
